import moment from 'moment';
import { CLEAR_HISTORY_TIMESTAMP_LOCAL_STORAGE_KEY } from '../../initialiser/constants';

export const visibleActivities = state => {
  const timestamp = window.localStorage.getItem(CLEAR_HISTORY_TIMESTAMP_LOCAL_STORAGE_KEY);

  const commandsSilent = [
    '/jumpToNode',
    '/restart',
    '/end',
    '/sreset',
    '/sback',
    '/reset',
    '/systemDisabledInputChat',
    '/systemEnabledInputChat'
  ];
  const isCommandSilent = activity =>
    activity.text && commandsSilent.includes(activity.text.split(' ')[0]);

  return timestamp
    ? state.history.activities.filter(
        activity =>
          !isCommandSilent(activity) &&
          activity.type !== 'event' &&
          moment(activity.timestamp).isSameOrAfter(timestamp)
      )
    : state.history.activities.filter(
        activity => !isCommandSilent(activity) && activity.type !== 'event'
      );
};



// WEBPACK FOOTER //
// ./src/reducers/history/selectors.js